import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSelectFeaturesInitialized } from "../../ducks/selectFeatures/selectors";
import { setSelectFeaturesInitialized } from "../../ducks/selectFeatures/selectFeatures";

export const useSelectFeaturesInitialized = (): [boolean, (value: boolean) => void] => {
  const dispatch = useDispatch();
  const value = useSelector(getSelectFeaturesInitialized);

  const update = useCallback(
    (state: boolean) => {
      dispatch(setSelectFeaturesInitialized(state));
    },
    [dispatch],
  );

  return [value, update];
};
